// 気象警報注意報・氾濫情報のコード辞書
// API仕様書「R08気象警報注意報API」の「気象警報コード」「氾濫に関する情報のコード体系」より
// code -> rawName（「レベルn」を含む場合があり、そこから警戒レベルを判定する）

export const ALERT_CODE_RAW_NAMES: Record<string, string> = {
  // 気象警報コード
  '00': '解除',
  '02': '暴風雪警報',
  '03': 'レベル3大雨警報',
  '04': '洪水警報',
  '05': '暴風警報',
  '06': '大雪警報',
  '07': '波浪警報',
  '08': 'レベル3高潮警報',
  '09': 'レベル3土砂災害警報',
  '10': 'レベル2大雨注意報',
  '12': '大雪注意報',
  '13': '風雪注意報',
  '14': '雷注意報',
  '15': '強風注意報',
  '16': '波浪注意報',
  '17': '融雪注意報',
  '18': '洪水注意報',
  '19': 'レベル2高潮注意報',
  '20': '濃霧注意報',
  '21': '乾燥注意報',
  '22': 'なだれ注意報',
  '23': '低温注意報',
  '24': '霜注意報',
  '25': '着氷注意報',
  '26': '着雪注意報',
  '29': 'レベル2土砂災害注意報',
  '32': '暴風雪特別警報',
  '33': 'レベル5大雨特別警報',
  '35': '暴風特別警報',
  '36': '大雪特別警報',
  '37': '波浪特別警報',
  '38': 'レベル5高潮特別警報',
  '39': 'レベル5土砂災害特別警報',
  '42': '将来的に予約',
  '43': 'レベル4大雨危険警報',
  '45': '将来的に予約',
  '46': '将来的に予約',
  '47': '将来的に予約',
  '48': 'レベル4高潮危険警報',
  '49': 'レベル4土砂災害危険警報',
  // 氾濫に関する情報のコード体系
  '110': 'レベル2氾濫注意報解除',
  '120': 'レベル2氾濫注意報（発表）',
  '121': 'レベル2氾濫注意報',
  '122': 'レベル2氾濫注意報（警報解除）',
  '130': 'レベル3氾濫警報（発表）',
  '131': 'レベル3氾濫警報',
  '140': 'レベル4氾濫危険警報（発表）',
  '141': 'レベル4氾濫危険警報',
  '151': 'レベル5氾濫特別警報',
  '153': 'レベル5氾濫特別警報',
}

// 履歴ページの列（気象種別）定義
// 1種別が注意報/警報/危険警報/特別警報・氾濫情報など複数コードを束ねる。配列順がそのまま列順
export type WeatherWarningColumn = {
  name: string
  codes: string[]
}

export const WEATHER_WARNING_COLUMNS: WeatherWarningColumn[] = [
  { name: '大雨', codes: ['03', '10', '33', '43'] },
  { name: '土砂災害', codes: ['09', '29', '39', '49'] },
  { name: '氾濫', codes: ['110', '120', '121', '122', '130', '131', '140', '141', '151', '153'] },
  { name: '高潮', codes: ['08', '19', '38', '48'] },
  { name: '洪水', codes: ['04', '18'] },
  { name: '強風', codes: ['15'] },
  { name: '暴風', codes: ['05', '35'] },
  { name: '風雪', codes: ['13'] },
  { name: '暴風雪', codes: ['02', '32'] },
  { name: '大雪', codes: ['06', '12', '36'] },
  { name: '波浪', codes: ['07', '16', '37'] },
  { name: '雷', codes: ['14'] },
  { name: '濃霧', codes: ['20'] },
  { name: '乾燥', codes: ['21'] },
  { name: 'なだれ', codes: ['22'] },
  { name: '低温', codes: ['23'] },
  { name: '霜', codes: ['24'] },
  { name: '着氷', codes: ['25'] },
  { name: '着雪', codes: ['26'] },
  { name: '融雪', codes: ['17'] },
]

// 「レベル」表記が無い場合に統一する既定の警戒レベル
export const DEFAULT_ALERT_LEVEL = 2

// code から警戒レベルを判定する
// 辞書の rawName に「レベルn」が含まれていれば n、無ければ DEFAULT_ALERT_LEVEL に統一する
export const resolveAlertLevel = (code?: string): number => {
  if (!code) {
    return DEFAULT_ALERT_LEVEL
  }

  const rawName = ALERT_CODE_RAW_NAMES[code]
  const matched = rawName?.match(/レベル(\d)/)

  return matched ? Number(matched[1]) : DEFAULT_ALERT_LEVEL
}
